import { QueryClient } from "@tanstack/react-query"
import type { ApiError } from "./api"

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      // Retry transient failures; avoid retrying client errors.
      retry: (failureCount, error) => {
        const status = (error as ApiError | undefined)?.status
        if (status && status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})
